var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#message_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M8.929 10a1.071 1.071 0 1 0 2.142 0 1.071 1.071 0 0 0-2.142 0m4.464 0a1.071 1.071 0 1 0 2.143 0 1.071 1.071 0 0 0-2.143 0m-8.929 0a1.071 1.071 0 1 0 2.143 0 1.071 1.071 0 0 0-2.143 0m14.76-3.875A10 10 0 0 0 10 0h-.045A9.977 9.977 0 0 0 0 10.047c.008 1.55.374 3.077 1.072 4.462v3.393a1.027 1.027 0 0 0 1.026 1.027h3.395A10 10 0 0 0 9.955 20h.047c1.337 0 2.634-.259 3.855-.766a9.9 9.9 0 0 0 3.188-2.125A9.976 9.976 0 0 0 20 10.044a10 10 0 0 0-.777-3.919m-3.373 9.777A8.26 8.26 0 0 1 10 18.304h-.039a8.3 8.3 0 0 1-3.864-.971l-.187-.1H2.768v-3.144l-.1-.187a8.3 8.3 0 0 1-.971-3.864A8.25 8.25 0 0 1 4.098 4.15a8.24 8.24 0 0 1 5.866-2.454h.038a8.26 8.26 0 0 1 5.875 2.431 8.271 8.271 0 0 1 2.43 5.91 8.27 8.27 0 0 1-2.456 5.865"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "message_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMessage;